export enum ApplyToEnum {
  ApplyToAllSelectedCompanies = 0,
  ApplyToSelectedOnly = 1,
  ApplyToAllCompanies = 2,
  ApplyToTags = 3,
  IncorrectApply = -1
}
